// 'modal-category-product-color-select
document.addEventListener('DOMContentLoaded', () => {
  const modal_category_product_color_select = document.getElementById('modal-category-product-color-select');
  const /** @type Modal */ m = window.Modal.getOrCreateInstance(modal_category_product_color_select);
  const color_select_buttons = modal_category_product_color_select.querySelectorAll('button');
  color_select_buttons.forEach((button) => {
    button.addEventListener('click', () => {
      //add to cart
      m.hide();
    });
  });
});